import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="personFilled" ref={ref} {...props}>
      <path d="M12.05,11.9a4.58,4.58,0,1,1,4.58-4.58A4.58,4.58,0,0,1,12.05,11.9Z M20.1,21.25H3.91a.76.76,0,0,1-.75-.75,5.72,5.72,0,0,1,5.72-5.71h6.25a5.72,5.72,0,0,1,5.72,5.71A.76.76,0,0,1,20.1,21.25Z" />
    </Icon>
  ),
) as IconWithRender;

PersonFilledIcon.displayName = 'PersonFilledIcon';
PersonFilledIcon.renderIcon = (props) => <PersonFilledIcon {...props} />;
export default PersonFilledIcon;
